import { config } from '@/components/state-pill/config';
import { AdState } from '@/models/ad';
import { cx } from '@emotion/css';
import { FC } from 'react';
import { Trans } from 'react-i18next';

const noPulsingStates = ['DELETED', 'STOPPED'];

export const StatePill: FC<{
  state: AdState;
}> = ({ state }) => {
  const { textColor, bgColor, dotColor, labelKey } = config[state];

  return (
    <div className={cx('flex gap-2 px-3 py-1 rounded-full ', bgColor)}>
      <div className="flex items-center gap-2">
        <span className="relative flex size-3">
          {!noPulsingStates.includes(state) ? (
            <span
              className={cx(
                'absolute inline-flex h-full w-full animate-ping rounded-full',
                dotColor
              )}
            ></span>
          ) : null}
          <span
            className={cx('relative inline-flex size-3 rounded-full', dotColor)}
          ></span>
        </span>
        <span className={cx('font-medium', textColor)}>
          <Trans i18nKey={labelKey} />
        </span>
      </div>
    </div>
  );
};
